import type { AudioEngine } from "../host/engine";
import type { Instrument, SamplerRuntimeSample } from "../types";
import { drumKitSampleIds, isDrumsInstrument } from "../kernel/drumKit";
import { isSamplerInstrument, samplerPresetSampleIds } from "./preset";
import { getCachedSample } from "./loadSample";
import { getFactoryCycleSample } from "./factoryCycles";

export type SampleResolver = (id: string) => Promise<SamplerRuntimeSample | undefined>;

/**
 * Ensure sample ids referenced by sampler / sample-mode drum instruments
 * are loaded into the kernel. Factory cycles resolve in-process; others go
 * through an optional host resolver (OPFS).
 */
export async function pushSamplesForInstruments(
  engine: AudioEngine,
  instruments: Instrument[],
  resolve?: SampleResolver,
): Promise<void> {
  const ids = new Set<string>();
  for (const instrument of instruments) {
    if (isSamplerInstrument(instrument)) {
      for (const id of samplerPresetSampleIds(instrument.preset)) {
        ids.add(id);
      }
    } else if (isDrumsInstrument(instrument)) {
      for (const id of drumKitSampleIds(instrument.kit)) {
        ids.add(id);
      }
    }
  }
  for (const id of ids) {
    let sample = getCachedSample(id) ?? getFactoryCycleSample(id);
    if (!sample && resolve) {
      sample = await resolve(id);
    }
    if (!sample) {
      continue;
    }
    engine.transport.loadSample(sample);
  }
}
